export default __webpack_public_path__ + "static/media/software-3.f4cda48a.png";